// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper--wh_97 {
  position: absolute;
  background-color: #2f2965;
  width: 100%;
  height: 100vh;
  left: 0;
  z-index: 1300; /* https://material-ui.com/customization/z-index/ */
}

.wrapper--wh_97 button {
  text-decoration: underline;
  cursor: pointer;
}

.wrapper--wh_97 button:hover {
  color: var(--color_orange-tangerine);
  transition: 0.3s ease-in;
}

.errorHeading--EnpOM {
  font-size: 1.35rem;
  color: var(--color_white-true);
  padding: 1.5rem 1rem 0;
  text-align: center;
}

.errorWrapper--hzAzh {
  text-align: center;
}

.sentry--eNQiz {
  font-size: 1.15rem;
  color: var(--color_white-true);
}

.errorMessage--rC4vy {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.6);
  padding: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/common/components/error-component/error.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,OAAO;EACP,aAAa,EAAE,mDAAmD;AACpE;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,aAAa;AACf","sourcesContent":[".wrapper {\n  position: absolute;\n  background-color: #2f2965;\n  width: 100%;\n  height: 100vh;\n  left: 0;\n  z-index: 1300; /* https://material-ui.com/customization/z-index/ */\n}\n\n.wrapper button {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.wrapper button:hover {\n  color: var(--color_orange-tangerine);\n  transition: 0.3s ease-in;\n}\n\n.errorHeading {\n  font-size: 1.35rem;\n  color: var(--color_white-true);\n  padding: 1.5rem 1rem 0;\n  text-align: center;\n}\n\n.errorWrapper {\n  text-align: center;\n}\n\n.sentry {\n  font-size: 1.15rem;\n  color: var(--color_white-true);\n}\n\n.errorMessage {\n  font-size: 1rem;\n  color: rgba(255, 255, 255, 0.6);\n  padding: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
export var wrapper = `wrapper--wh_97`;
export var errorHeading = `errorHeading--EnpOM`;
export var errorWrapper = `errorWrapper--hzAzh`;
export var sentry = `sentry--eNQiz`;
export var errorMessage = `errorMessage--rC4vy`;
export default ___CSS_LOADER_EXPORT___;
